<template>
  <van-dialog v-model="showModel" title="订单退款" show-cancel-button :before-close="onAction">
    <p class="tip" v-if="message">{{ message }}</p>
    <van-field label="金额" :value="amountStr" readonly />
    <van-field v-model="remark" label="退款原因" placeholder="请输入信息" />
  </van-dialog>
</template>
<script>
import { refundOrder as refundOrderAuction } from '@/api/orderAuction';
import { refundOrder as refundOrderMargin } from '@/api/orderMargin';
import { refundOrder as refundOrderGood } from '@/api/order';
export default {
  components: {},
  model: {
    prop: 'show',
    event: 'showChanged',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return null;
      },
    },
    type: { type: Number, default: 0 },
  },
  data() {
    return {
      showModel: false,
      message: null,
      remark: null,
      refundMethod: null,
    };
  },
  watch: {
    show: function(val) {
      this.showModel = val;
    },
    showModel: function(val) {
      this.$emit('showChanged', val);
    },
    order: {
      handler(val) {
        if (val.payType == 10) {
          this.message =
            '此订单为线下支付，请先通过线下方式退款，再进行退款申请。系统会修改订单状态为“已退款”，确定进行退款申请吗？';
        }

        if (this.type == 44 && val.payTypeSet == 2) {
          this.message =
            '此订单为线下支付，请先通过线下方式退款，再进行退款申请。系统会修改订单状态为“已退款”，确定进行退款申请吗？';
        } else if (this.type == 44 && val.payTypeSet == 3) {
          this.message =
            '此订单包含线下支付，请先通过线下方式退还线下支付款项，再进行退款申请。系统会将线上缴纳款项退还，且会修改订单状态为“已退款”，确定进行退款申请吗？';
        }
      },
    },
  },
  computed: {
    amountStr() {
      let amount;
      if (this.order && this.type == 44) {
        // 保证金
        amount = `${this.order.mainCurrency ? this.order.mainCurrency.mark : '¥'} ${
          this.order.marginAmount
        }`;
      } else if (this.order && this.type == 47) {
        //拍品
        amount = `${this.order.mainCurrency ? this.order.mainCurrency.mark : '¥'} ${
          this.order.payAmount
        }`;
      } else if (this.order && this.type == 35) {
        // 商品
        amount = `¥ ${this.order.payAmount}`;
      } else {
        amount = '';
      }
      return amount;
    },
    amount() {
      let amount;
      if (this.order && this.type == 44) {
        //保证金
        amount = this.order.marginAmount;
      } else if (this.order && this.type == 47) {
        // 拍品
        amount = this.order.payAmount;
      } else if (this.order && this.type == 35) {
        // 商品
        amount = this.order.payAmount;
      } else {
        amount = 0;
      }
      return amount;
    },
  },
  methods: {
    getRefundFunction() {
      let refundMethod;
      if (this.type == 44) {
        refundMethod = refundOrderMargin;
      } else if (this.type == 47) {
        refundMethod = refundOrderAuction;
      } else if (this.type == 35) {
        refundMethod = refundOrderGood;
      }
      return refundMethod;
    },
    onAction(action, done) {
      if (action === 'confirm') {
        console.log(this);
        this.getRefundFunction()({
          id: this.order.id,
          returnAmount: this.amount,
          body: this.remark,
        })
          .then(res => {
            this.$emit('refund-success', res.data);
            done();
          })
          .catch(err => {
            done();
          });
      } else {
        done();
      }
    },
  },
};
</script>
<style scoped>
.tip {
  color: #646566;
  font-size: 14px;
  padding: 10px 16px;
}
</style>
